export default [
  {
    path: '/',
    redirect: {
      name: 'inicio'
    }
  },
  {
    path: '/inicio',
    name: 'inicio',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/formatos',
    name: 'formatos',
    component: () => import('@/views/Formatos.vue')
  },
  {
    path: '/escuelas',
    name: 'escuelas',
    component: () => import('@/views/Teachers.vue')
  },
  {
    path: '/vacantes',
    name: 'vacantes',
    component: () => import('@/views/Vacant.vue')
  },
  {
    path: '/reporte-inscritos',
    name: 'reporte-inscritos',
    component: () => import('@/views/registereds/UserReport.vue')
  },
  {
    path: '/foto',
    name: 'foto',
    component: () => import('@/views/registereds/camara.vue')
  },
  {
    path: '/cronograma',
    name: 'cronograma',
    component: () => import('@/views/Data.vue')
  },
  {
    path: '/modalidades',
    name: 'modalidades',
    component: () => import('@/views/Modality.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/components/Login.vue')
  },
  {
    path: '/preinscripcion',
    name: 'preinscripcion',
    component: () => import('@/views/admision/admision.vue')
  },
  /*
  {
    path: '/preinscripcion-cepre',
    name: 'preinscripcionCepre',
    component: () => import('@/views/admision/cepre.vue')
  }, */
  {
    path: '/beca18',
    name: 'beca18',
    component: () => import('@/views/admision/inscripcion.vue')
  },
  {
    path: '/preinscritos',
    name: 'preinscritos',
    component: () => import('@/views/registereds/List.vue')
  },
  {
    path: '/preinscripcion-traslado-externo',
    name: 'preinscritosTraslado',
    component: () => import('@/views/admision/Extra.vue')
  },
  // sgc users
  {
    path: '/users',
    name: 'sgcUsersList',
    component: () => import('@/views/users/ListUsers.vue')
  },
  {
    path: '/users/create',
    name: 'sgcUsersCreate',
    component: () => import('@/views/users/CreateUser.vue')
  },
  {
    path: '/users/:id',
    name: 'sgcUsersEdit',
    component: () => import('@/views/users/EditUser.vue')
  },
  // inscritos
  {
    path: '/preinscrito/:id',
    name: 'registerEdit',
    component: () => import('@/views/registereds/Edit.vue')
  },
  {
    path: '/inscritos',
    name: 'inscritos',
    component: () => import('@/views/registereds/Inscribed.vue')
  },
  {
    path: '/camara/:id',
    name: 'camara',
    component: () => import('@/views/registereds/foto.vue')
  },
  {
    path: '/reporte/:id',
    name: 'reporte',
    component: () => import('@/views/registereds/Report.vue')
  },
  {
    path: '/reporte-preinscripcion/:id',
    name: 'reportePreinscription',
    component: () => import('@/views/registereds/ReportPreinscription.vue')
  },

  // school
  {
    path: '/school/create',
    name: 'createSchool',
    component: () => import('@/views/school/Create.vue')
  },
  {
    path: '/reporte-admision',
    name: 'reportAdmin',
    component: () => import('@/views/registereds/ReportesAdmin.vue')
  },
  {
    path: '/anulados',
    name: 'annulled',
    component: () => import('@/views/registereds/Annulled.vue')
  },
  /*
  // cepre
  {
    path: '/preinscritoscepre',
    name: 'preinscritoscepre',
    component: () => import('@/views/cepre/Preinscribed.vue')
  },
  */
  /*
  {
    path: '/inscritoscepre',
    name: 'inscritoscepre',
    component: () => import('@/views/cepre/Inscribed.vue')
  },
  */
  {
    path: '/verificar-inscripcion',
    name: 'verify',
    component: () => import('@/views/admision/verificar.vue')
  },
  {
    path: '/descargapagos',
    name: 'descargapagos',
    component: () => import('@/views/DescargaPagos.vue')
  }
]
